<template>
    <div class="index-container">
        <Header></Header>
        <div class="page-container">
            <div class="page-wrapper">
                <div class="page-back-wrapper">
                    <div class="page-back" @click="toSyc">
                        <img src="@/assets/img/back.png" alt="" class="page-back-img">
                        <span>返回</span>
                    </div>
                    <div v-if="modeParams == 'live-learn' || modeParams === 'record-learn'"
                        class="live-learn-title-wrapper">
                        课程名称：
                        <span class="live-learn-title">{{ liveLearnData.title || liveLearnData.description }}</span>
                        <span class="live-learn-title-flag" v-if="modeParams == 'live-learn'">直播</span>
                    </div>
                    <div v-else class="live-learn-title-wrapper">
                        课程名称：
                        <span class="live-learn-title">{{ liveLearnData.title || liveLearnData.description }}</span>
                        <span class="live-learn-title-flag" v-if="modeParams == 'live-learn'">直播</span>
                    </div>
                </div>

                <div class="page-content-wrapper">
                    <div class="page-content">
                        <div class="video-wrapper" v-loading="loadingVideo">
                            <div id="myVideoDiv" v-show="!noVideoShow && modeParams !== 'live-learn'">
                                <video id="J_VideoJS" class="video-js vjs-big-play-centered"></video>
                            </div>
                            <div v-show="!noVideoShow && modeParams === 'live-learn'" class="prism-player"
                                id="J_prismPlayer">
                            </div>
                            <div v-show="noVideoShow">
                                <!-- <span class="no-video"></span> -->
                                <img :src="coverUrl" class="no-video-img-wrapper" />
                                <span class="no-video-wrapper">{{ noDataContent }}</span>
                            </div>
                        </div>
                        <div v-if="modeParams != 'live-learn' && modeParams != 'aaaaaaaaaaaa'" class="catalogue-wrapper">
                            <div class="catalogue-header">
                                <img src="@/assets/img/menu.png" alt="" class="menu-img">
                                目录
                            </div>
                            <!-- -->
                            <div v-if="btnType.showStatus == 1" class="jyxz" @click="jxyz">下载讲义
                            </div>
                            <div class="catalogue-collapse">
                                <TreeMenus :list="collapseData" :currentKey="currentKey"
                                    :name="liveLearnData.title || liveLearnData.description"
                                    :defaultExpandedKeys="defaultExpandedKeys" @menu="getMenu" @numVal="getNumVal">
                                </TreeMenus>
                            </div>
                        </div>
                    </div>
                    <div class="course-pay-wrapper" v-if="modeParams == 'live-learn' && showAppointment">
                        <div v-if="modeParams == 'live-learn'" class="live-learn-time">
                            直播时间：{{ liveLearnData.startTime }}
                        </div>
                        <div class="course-pay-btn animate" @click="bookLive">预约</div>
                    </div>
                    <div v-if="modeParams == 'live-learn' && showEnter263Live && aa !== 'aa'"
                        class="live-course-appointment">
                        <div class="course-pay-btn animate" @click="enter263Live">进入直播</div>
                    </div>
                    <!-- 公开课预约 -->
                    <div v-if="modeParams == 'live-learn' && liveCourseAppointment" class="live-course-appointment">
                        <div class="course-pay-btn animate" @click="onLiveCourseAppointment">预约</div>
                    </div>
                    <div class="page-content-detail">
                        <div v-if="modeParams == 'live-learn' || modeParams == 'aaaaaaaaaaaa'"
                            class="page-content-detail-header">
                            <div class="page-content-detail-header-item-active">直播详情</div>
                        </div>
                        <div v-else class="page-content-detail-header">
                            <div :class="activeTab == 'introduction' ? 'page-content-detail-header-item-active' : 'page-content-detail-header-item'"
                                @click="handleTab('introduction')">介绍</div>
                            <div :class="activeTab == 'list' ? 'page-content-detail-header-item-active' : 'page-content-detail-header-item'"
                                @click="handleTab('list')">课程目录</div>
                            <div :class="activeTab == 'ppt' ? 'page-content-detail-header-item-active' : 'page-content-detail-header-item'"
                                @click="handleTab('ppt')">讲义</div>
                            <div :class="activeTab == 'relevant' ? 'page-content-detail-header-item-active' : 'page-content-detail-header-item'"
                                @click="handleTab('relevant')">相关</div>
                        </div>
                        <div class="page-content-detail-content">
                            <div v-if="activeTab == 'introduction'" class="induction-wrapper">
                                <div class="page-content-detail-content-header">
                                    <div class="circle-img1-wrapper">
                                        <img src="@/assets/img/circle1.png" alt="" class="circle-img1">
                                    </div>
                                    <div class="circle-img2-wrapper">
                                        <img src="@/assets/img/circle2.png" alt="" class="circle-img2">
                                    </div>
                                    <div class="page-content-detail-content-header-title">课程概述</div>
                                </div>
                                <div v-html="imageTextDescription" class="induction-content"></div>
                            </div>
                            <div v-else-if="activeTab == 'list'" class="catalogue-content-wrapper">
                                <CatalogueTreeMenus :name="liveLearnData.title || liveLearnData.description"
                                    :list="collapseData" :currentKey="currentKey" :defaultExpandedKeys="defaultExpandedKeys"
                                    @menu="getMenu" @numVal="getNumVal">
                                </CatalogueTreeMenus>
                            </div>
                            <div v-else-if="activeTab == 'relevant'" class="catalogue-content-wrapper">
                                <Relevant :courseId="recordId" />
                            </div>
                            <div v-else class="induction-wrapper">
                                <div class="page-content-detail-content-header">
                                    <div class="circle-img1-wrapper">
                                        <img src="@/assets/img/circle1.png" alt="" class="circle-img1">
                                    </div>
                                    <div class="circle-img2-wrapper">
                                        <img src="@/assets/img/circle2.png" alt="" class="circle-img2">
                                    </div>
                                    <div class="page-content-detail-content-header-title"></div>
                                </div>
                                <!-- <div v-for="(item, key) in recordInfo.jpgs" :key="'ppt-' + key" class="induction-content">
                                    <img :src="item.sourceUrl" alt="">
                                </div> -->
                                <template v-if="recordInfo.jpgs && recordInfo.jpgs.length">
                                    <div v-for="(item, key) in recordInfo.jpgs" :key="'ppt-' + key"
                                        class="induction-content">
                                        <img :src="item.sourceUrl" alt @contextmenu.prevent />
                                    </div>
                                </template> <template v-else-if="recordInfo.pdf">
                                    <!-- height:700px;overflow: hidden;overflow-y: auto; -->
                                    <div style="height:100%;" @contextmenu.prevent>
                                        <iframe id="iframe" ref="iframe" :src="recordInfo.pdf.sourceUrl + '#toolbar=0'"
                                            width="100%" height="700px"></iframe>
                                        <!-- <pdf :pdfSrc="recordInfo.pdf.sourceUrl"></pdf> -->
                                    </div>
                                </template>
                                <template v-else>
                                    <!-- <div class="empty" :alt="courseInfo.watchPermission ? 'PPT正在设计中，请稍等~' : '您还未拥有该课程'">
                    <img src="../../assets/img/empty.png" alt />
                  </div> -->
                                    <div class="empty" alt="PPT正在设计中，请稍等~ ">
                                        <!-- <img src="../../assets/img/empty.png" alt /> -->
                                        <img src="../../../assets/img/empty.png" alt="">
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="" :show-close="true" width="542px" :visible.sync="bookComfirm" class="team-manage-container">
            <div class="dialog-header">
                <div>温馨提示</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-info">
                    <div>预约精品课程需要消耗直播课次，</div>
                    <div>当前剩余{{ bookTimes }}次，确认预约？</div>
                </div>
                <div class="dialog-btn-wrapper">
                    <el-button @click="cancelBook">取消</el-button>
                    <el-button type="primary" @click="dealBook">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="线上公开课预约" :show-close="true" width="600px" :visible.sync="showLiveCourseAppointment"
            custom-class="appointment-active-container resetDialog">
            <div class="dialog-content">
                <div class="course-name-wrap">
                    {{ liveCourseAppointmentData.courseName }}
                </div>
                <!-- <el-tabs v-model="appointmentActiveName" class="course-name-tabs">
                    <el-tab-pane label="基本信息" name="info"></el-tab-pane>
                </el-tabs> -->
                <div class="info">基本信息</div>
                <el-form ref="form" label-width="90px" :label-position="'left'">
                    <el-form-item label="企业名称">
                        <div class="page-info-content-company-name">
                            {{ companyDetail.companyName }}
                        </div>
                        <div class="page-info-refresh">
                            <el-dropdown @command="handleDropdown">
                                <div class="el-dropdown-link compony-dropdown">
                                    <div class="page-info-shape-wrapper">
                                        <img src="../../../assets/img/hhkuang.png" alt="" class="image">
                                    </div>
                                    <img src="../../../assets/img/huhuan.png" alt="" class="branch-image">
                                    <div class="page-info-refresh-label">切换企业</div>
                                </div>
                                <el-dropdown-menu slot="dropdown" class="company-dropdown-wrap">
                                    <el-dropdown-item v-for="(item, key) in liveCourseAppointmentData.companyList"
                                        :key="'dropdown-' + key" :command="item">
                                        <el-radio v-model="item.check" :label="item.deptId">
                                            {{ item.companyName }}
                                        </el-radio>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </el-form-item>
                    <el-form-item label="我的手机号">
                        {{ liveCourseAppointmentData.mobile }}
                    </el-form-item>
                    <el-form-item label="本次公开课">
                        未预约
                    </el-form-item>
                </el-form>
                <div class="dialog-appointment-btn-wrapper">
                    <!-- <el-button @click="cancelBook">取消</el-button> -->
                    <el-button type="primary" class="submit-btn" @click="submitLiveCourseAppointment">确认预约</el-button>
                </div>
                <div class="desc-wrap">
                    <div>说明：</div>
                    <div>1.预约成功后扣减一次公开课剩余次数; 2.预约成功后不可修改学员信息或取消预约。</div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :title="tipTitle" :visible.sync="tipVisible" width="30%" :show-close="tipTitle ? true : false"
            custom-class="appointment-tip-container">
            <div v-if="!tipTitle" class="success-tip-wrap">
                <img src="@/assets/img/successTip.png" alt class="success-tip-logo" />
                <div>预约成功</div>
            </div>
            <div v-else class="error-tip-wrap">
                <div class="tip-text">{{ tipMsg }}</div>
                <el-button type="primary" @click="tipVisible = false">知道了</el-button>
            </div>
        </el-dialog>
        <!-- 课程评价 -->
        <el-dialog title="课程评价" :visible.sync="dialogExchange2" width="400px" class="dialog-exchange-wrapper"
            @close="toSyc(1)" :close-on-press-escape='false' :close-on-click-modal='false'>
            <div class="dialog-exchange-content">
                <el-form ref="exchangeForm2" :model="exchangeForm2" :rules="exchangeRules2">
                    <el-form-item>
                        <div style="width:350px;text-align: center;color: #ccc;">为了更好地服务学员，您的评价对我们至关重要。</div>
                        <el-rate v-model="exchangeForm2.starCount" style="width:200px;margin: 0 auto;">
                        </el-rate>
                    </el-form-item>
                    <el-form-item>
                        <el-input type="textarea" v-model="exchangeForm2.content" placeholder="请输入你的评价" />
                    </el-form-item>
                </el-form>
                <div class="dialog-btn-wrapper">
                    <el-button v-if="exchangeForm2.starCount == 0" :disabled="true"
                        style="width: 400px; border-radius: 40px;font-size:16px" type="primary">提交</el-button>
                    <el-button v-else style="width: 400px;background: #0F6CF5; border-radius: 40px;font-size:16px"
                        type="primary" @click="submitExchange2">提交</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import 'videojs-contrib-hls'
import {
    oldGetCourseDetailCatalogue,
    oldGetCourseDetailIntroduction,
    oldUpdateStudyProgress,
    getCourseDetailCatalogue,
    getCourseDetailIntroduction,
    updateStudyProgress,
    getVideoProgress,
    liveCourseDetail,
    h5LiveCourseDetail,
    liveCourseSignIn,
    appointmentCourseTimes,
    appointmentCourse,
    onlineOpenCourseDetail,
    appointmentOnlineOpenCourse,
    getLiveAuthAddress, liveupdateStudyProgress, lecturesDownload, submitEvaluate, userEvaluate, logVideo
} from '@/api/index.js';
import Header from '@/components/Header.vue'
import TreeMenus from '@/components/TreeMenus.vue'
import CatalogueTreeMenus from '@/components/catalogueTreeMenus.vue'
import Relevant from './relevant'
import pdf from '@/components/pdf';
export default {
    name: '',
    components: {
        Header, pdf,
        TreeMenus,
        CatalogueTreeMenus,
        Relevant
    },
    data() {
        return {
            ISlogVideo: true,
            exchangeForm2: {
                courseId: "",
                content: "",
                starCount: 0,
            },
            exchangeRules2: {
                starCount: [
                    { required: true, message: "请输入评价星及", trigger: ["blur", 'change'] },
                ],
                content: [{ required: true, message: "请输入评价内容", trigger: "blur" }],
            },
            dialogExchange2: false,
            timemiao: 0,
            aa: '',
            modeParams: '',
            recordId: null,
            activeName: "0",
            activeTab: 'introduction',
            collapseData: [],
            introduction: "",
            videoURL: "",
            recordInfo: {},
            myPlayer: null,
            vPlayer: null,
            parseNum: 0,
            dept: '',
            token: '',
            noVideoShow: true,
            coverUrl: '',
            liveLearnData: {},
            defaultExpandedKeys: [],
            currentKey: null,
            playCount: null,
            timeCount: null,
            isPlay: false,
            studyLessonPosition: 0, // 播放位置
            lastState: 0, // 上一次记录时间
            videoType: 1,
            avtiveMenu: null, // 当前点击菜单
            isInit: true, // 是不是第一个进入
            isLive: false, // 是否为直播
            noDataContent: '请选择相应章节播放~',
            countdDownInterval: null, // 定时器
            imageTextDescription: '',
            loadingVideo: false,
            showAppointment: false, // 展示预约
            bookComfirm: false,
            liveCourseAppointment: false,
            appointmentActiveName: 'info',
            showLiveCourseAppointment: false,
            liveCourseAppointmentData: {
                companyList: [],
                courseName: '',
                mobile: '',
            },
            companyDetail: {
                companyName: '',
            },
            companyData: [],
            bookTimes: 0,
            isRelevantInto: false, // 是不是从相关进去的
            tipVisible: false,
            tipTitle: '',
            tipMsg: '',
            showEnter263Live: false, btnType: {

            }, playbackRate: 1,
        }
    },
    created() {
        scrollTo(0, 0);
        this.dept = this.$route.params.dept;
        this.token = window.localStorage.getItem('token');
        this.modeParams = this.$route.params.mode;
        this.videoType = this.$route.params.video;
        if (this.$route.query.isRelevantInto) {
            this.isRelevantInto = true
        }
        this.exchangeForm2.courseId = this.$route.params.id
        this.setTimeIS(this.$route.params.id, 0)
    },
    async mounted() {
        var recordId = this.$route.params.id;
        this.recordId = recordId;
        var modeParams = this.modeParams;
        if (modeParams == 'live-learn' && this.$route.query.courseType === '2') {
            console.log(11111111111111, 'live-learn', ' === 2')
            this.getLiveCourseTwo(recordId);
        } else if (modeParams == 'live-learn') {
            console.log(11111111111111, 'live-learn')
            this.getLiveCourse(recordId);
        } else {
            console.log(11111111111111, 'else')
            this.activeTab = 'list'
            await this.getCourseIntroduction(recordId);
            this.getCourseList(recordId);
        }
        this.getBtn()
    },
    methods: {

        //埋点上报
        LOGvIDEO(id) {
            logVideo({ recordId: id },
                {
                    Authorization: this.token ? this.token : '',

                }).then(res => {
                    if (res.code == 0) {
                        this.ISlogVideo = false
                    }
                })
        }
        ,
        //存储播放时长
        setTimeIS(ID, time) {

            var data = JSON.parse(localStorage.getItem('items'))
            if (data && data.id == ID) {
                data.time = data.time + time
                localStorage.setItem('items', JSON.stringify(data))

            } else {
                localStorage.setItem('items', JSON.stringify({
                    id: ID,
                    time: time
                }))
            }
        },
        //检查课程是否评价
        toSyc(tyepe) {

            if (!this.token) { tyepe = 1 }

            if (tyepe == 1) {

                this.handleBack()
            } else {

                userEvaluate({ courseId: this.recordId }, {
                    Authorization: this.token,
                    DeptId: this.deptId,
                }).then(res => {
                    if (res.code == 200) {
                        if (res.data.evaluate == 0) {
                            console.log('么有评价')
                            this.inspectItem()

                        } else {
                            console.log('评价过了')
                            this.handleBack()
                        }

                    }
                }).catch(() => {

                })
            }
        },
        //检查观看时间是否大于10分钟
        inspectItem() {
            var data = JSON.parse(localStorage.getItem('items'))
            if (data) {
                if (data.time >= 600) {
                    console.log('观看大于10分钟', data.time)
                    this.dialogExchange2 = true
                } else {
                    console.log('观看过咩有大于10分钟', data.time)
                    this.handleBack()
                }
            } else {
                console.log('么有观看过', data)
                this.handleBack()
            }
        },
        // 提交兑换课程
        submitExchange2() {
            this.$refs["exchangeForm2"].validate((valid) => {
                if (valid) {

                    submitEvaluate(
                        this.exchangeForm2,
                        {

                            Authorization: this.token,
                            DeptId: this.deptId,
                        }
                    )
                        .then((res) => {
                            if (res.code == 200) {
                                this.dialogExchange2 = false
                                this.$message({
                                    message: "评价成功",
                                    type: "success",
                                });

                            }
                            return;
                        })

                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        getBtn() {
            lecturesDownload({ recordId: this.recordId },

                {
                    Authorization: this.token,
                    DeptId: this.dept,
                }).then(res => {
                    if (res.code == 200) {
                        // "showStatus": 0, //1=显示下载讲义，0=不显示下载讲义
                        //   "permission": 1, //1=当前登录用户有课程观看权限，0=当前登录用户没有课程观看权限
                        //     "lecturesDownload": 1 //1=支持下载，0=有版权保护不支持下载
                        this.btnType = res.data
                    }
                    console.log(res, "****************1111")
                })
        },
        //讲义下载
        jxyz() {
            // if (this.intoType !== 'myOrder' && this.initCourseInfoFlag && !this.courseInfo.watchPermission) {
            //     if (this.courseInfo.price > 0) {
            //         this.$message.error("请先购买此课程");
            //     } else {
            //         this.$message.error("请加入先加入学习");
            //     }
            // } else {

            if (this.btnType.permission == 1) {
                if (this.btnType.lecturesDownload == 1) {
                    this.$router.push(`/jyml/${this.recordId}`);
                } else {
                    this.$message.error("因版权保护暂不支持下载");
                }
            } else {
                this.$message.error("当前登录用户没有课程观看权限");
            }

            //    }



        },
        bof(url, id) {
            console.log('************************************************bof');
            let _this = this
            var typeS = null
            this.noVideoSho = false
            this.modeParams = 'aaaaaaaaaaaa'
            let video = document.getElementById("J_VideoJS");
            let options = {
                controls: true, //是否显示播放器控件
                autoplay: true, //是否自动播放
                width: 767, //视频的宽度
                height: 429, //视频的高度
                playbackRates: [1, 1.25, 1.5, 2],
                controlBar: {
                    //底部的控制栏组件
                    currentTimeDisplay: true, //当前播放事件
                    timeDivider: true, //当前播放时间与总时间的斜杆分隔符
                    durationDisplay: true, //是否显示总时间
                    remainingTimeDisplay: false, //是否显示剩下的时间，该选项与是否显示总时间二选一
                    volumePanel: {
                        //音量组件
                        inline: true, //可以调整方向为纵向或者横向
                    },
                    children: [
                        //children数组这是controlbar的子元素顺序
                        {
                            name: "playToggle",
                        },
                        {
                            name: "volumePanel",
                        },
                        {
                            name: "currentTimeDisplay",
                        },
                        {
                            name: "progressControl",
                        },
                        {
                            name: "durationDisplay",
                        },
                        {
                            name: "playbackRateMenuButton",
                            playbackRates: [1, 1.25, 1.5, 2],
                        },
                        {
                            name: "FullscreenToggle",
                        },
                    ],
                },
            };

            this.player = this.$video(video, options);

            this.player = this.$video(video, options, function () {
                let timeout = 0;
                this.on("play", function () {
                    console.log('我播放了');
                    _this.timeCount = setInterval(function () {
                        timeout++;

                    }, 1000);
                    _this.playCount = setInterval(() => {
                        liveupdateStudyProgress({
                            "infoId": id, //直播id
                            "studyTime": timeout * _this.playbackRate, //学习时间(单位秒，同录播课)
                            "studyPosition": this.currentTime() //学习位置（同录播课）
                        }, {
                            Authorization: _this.token,
                            DeptId: _this.dept,
                        })
                        timeout = 0;
                    }, 60000);
                });
                this.on("pause", function () {
                    console.log('我暂停了')
                    liveupdateStudyProgress({
                        "infoId": id, //直播id
                        "studyTime": timeout * _this.playbackRate, //学习时间(单位秒，同录播课)
                        "studyPosition": this.currentTime() //学习位置（同录播课）
                    }, {
                        Authorization: _this.token,
                        DeptId: _this.dept,
                    })
                    //this.currentTime()播放的秒
                    // console.log('pause', timeout, this.currentTime());
                    timeout = 0;
                    clearInterval(_this.timeCount);
                    clearInterval(_this.playCount);
                });
                this.on("timeupdate", (e) => {
                    // console.log('timeupdate');
                    if (
                        Math.floor(this.duration()) === Math.floor(this.currentTime())
                    ) {
                        _this.studyLessonPosition = 0;
                    } else if (Math.floor(this.currentTime())) {
                        _this.studyLessonPosition = Math.floor(this.currentTime());
                    }
                    _this.setCollapseData(_this.collapseData);
                });

                var seeked = false;
                // 设置进度条
                this.on("canplaythrough", function (e) {

                    if (!seeked) {
                        seeked = true;
                        this.currentTime(_this.lastState);
                    }

                });
                // 监听播放速度改变事件
                this.on('ratechange', function () {
                    // 获取当前播放速度
                    var playbackRate = this.playbackRate();
                    console.log('播放速度已更改为22222222222:', playbackRate);
                    _this.playbackRate = playbackRate
                    //////////////////////////////////////////////////
                    liveupdateStudyProgress({
                        "infoId": id, //直播id
                        "studyTime": timeout, //学习时间(单位秒，同录播课)
                        "studyPosition": this.currentTime() //学习位置（同录播课）
                    }, {
                        Authorization: _this.token,
                        DeptId: _this.dept,
                    })
                    timeout = 0;

                });

            });


            // if (url.indexOf('m3u8') !== -1) {
            //     typeS = "application/x-mpegURL"
            // } else if (url.indexOf('.mp3') !== -1) {
            //     typeS = "audio/mp3"
            // } else {
            //     typeS = "video/mp4"
            // }

            if (this.getLastSuffix(url).indexOf('m3u8') !== -1) {
                typeS = "application/x-mpegURL"
            } else if (this.getLastSuffix(url).indexOf('mp4') !== -1) {
                typeS = "audio/mp3"
            } else {
                typeS = "video/mp4"
            }
            console.log('url', url);
            console.log('typeS', typeS);
            this.player.src([
                {
                    src: url,
                    type: typeS, // 告诉videojs,这是一个hls流
                },
            ]);
        },
        getLastSuffix(str, delimiter = '.') {
            const parts = str.split(delimiter);
            return parts[parts.length - 1];
        },
        handleBack() {
            // 如果是相关点进来的页面返回上一个页面
            // if (this.isRelevantInto) {
            //     history.back()
            // }

            // var modeParams = this.modeParams;
            // if (modeParams == 'plan') {
            //     var planData = JSON.parse(window.localStorage.getItem('plan'));
            //     var planId = planData.id;
            //     this.$router.push(`/planDetail/edit/${planId}`);
            // } else if (modeParams == 'record-learn') {
            //     this.$router.push(`/myRights/record-learn`);
            // } else if (modeParams == 'live-learn') {
            //     this.$router.push(`/myRights/live-learn`);
            // } else {
            //     this.$router.push(`/index/enterprise-center/${this.dept}/${this.token}`);
            // }
            localStorage.removeItem('items')
            history.back()
        },
        handleTab(target) {
            this.activeTab = target;
        },
        getLiveCourse(id) {

            h5LiveCourseDetail(id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {

                    var data = res.data;
                    this.liveLearnData = data;
                    this.coverUrl = data.coverUrl;
                    this.introduction = data.description;
                    this.imageTextDescription = data.description
                    // this.coverUrl = data.coverUrl;
                    this.noVideoShow = false;
                    var status = data.liveStatus;
                    if (data.appointmentStatus === 2) {
                        this.showAppointment = true
                        // return
                    }
                    if (this.countdDownInterval) {
                        window.clearInterval(this.countdDownInterval)
                    }

                    switch (status) {
                        case 0: // 未开始
                            this.noVideoShow = true;
                            this.noDataContent = data.remainingFormatTime
                            this.countdDownInterval = setInterval(() => {
                                this.noDataContent = this.countdDown(data)
                            }, 1000);  //反复执行函数本身
                            break;
                        case 1: // 直播
                            // this.loadingVideo = true
                            this.videoURL = data.playHlsUrl;
                            this.isLive = true
                            // console.log("********************************222222");
                            this.videoInit(data.infoId);
                            this.initVideoJS(data.infoId);
                            break;
                        case 2: console.log("回放生成中")
                            this.noVideoShow = true;
                            this.noDataContent = '回放生成中';
                            break;
                        case 3:
                            this.lastState = data.lastStudyPosition
                            if (data.highDefinitionUrl !== null && data.highDefinitionUrl !== '') {
                                //   console.log('data.highDefinitionUrl1111111111111111', data.highDefinitionUrl)
                                this.videoURL = data.highDefinitionUrl;
                                this.bof(data.highDefinitionUrl, data.infoId)
                            } else if (data.standardDefinitionUrl !== null && data.standardDefinitionUrl !== '') {
                                this.videoURL = data.standardDefinitionUrl;
                                //  console.log('data.standardDefinitionUr22222222222222', data.standardDefinitionUrl); this.bof(data.standardDefinitionUrl, data.infoId)
                            } else if (data.fluencyDefinitionUrl !== null && data.fluencyDefinitionUrl !== '') {
                                this.videoURL = data.fluencyDefinitionUrl;
                                //    console.log('data.fluencyDefinitionUrl333333333333333333', data.fluencyDefinitionUrl); this.bof(data.fluencyDefinitionUrl, data.infoId)
                            } else if (data.sourceUrl !== null && data.sourceUrl !== '') {
                                console.log('data.sourceUrl4444444444444444444444444444', data.sourceUrl, data.infoId)
                                this.videoURL = data.sourceUrl;
                                this.bof(data.sourceUrl, data.infoId)
                                //  this.videoInit(data.infoId, '11111');
                                //   this.initVideoJS(data.infoId);
                            }

                            //    this.loadingVideo = true
                            // this.videoURL = data.vodMp4Url;
                            break;
                    }
                    if (!this.showAppointment && this.liveLearnData.source === 2) {
                        this.showEnter263Live = true
                    }
                    this.videoInit(data.infoId);
                    //  this.initVideoJS(data.infoId);
                } else {
                    this.$message.error(res.msg);
                    this.handleBack()
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        // 直播公开课
        getLiveCourseTwo(id) {

            this.noDataContent = ''
            h5LiveCourseDetail(id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                // console.log("********************************55555555555", res);
                if (res.code == 200) {

                    var data = res.data;
                    this.lastState = data.lastStudyPosition
                    this.liveLearnData = data;
                    this.imageTextDescription = data.description
                    this.countdDownInterval && window.clearInterval(this.countdDownInterval)
                    if (data.appointmentStatus === 2) {

                        this.noDataContent = '您还未预约当前直播，请联系课程顾问为您预约！'
                        // (0未开始 1-直播中 2-直已束，未生成回放 3-直已结束，已生成回放

                        switch (data.liveStatus) {
                            case 0:
                                this.noDataContent = data.remainingFormatTime
                                this.countdDownInterval = setInterval(() => {
                                    this.noDataContent = this.countdDown(data)
                                }, 1000);  //反复执行函数本身
                                break;
                            case 1:
                                this.noDataContent = '直播中，预约课程即可观看'
                                break;
                            case 2:
                                this.noDataContent = '直播已结束 回放生成中，请稍后观看'
                                break;
                            case 3:
                                this.noDataContent = '回放已生成，预约后即可观看'
                                break;

                            default:
                                break;
                        }
                        this.liveCourseAppointment = true
                        return
                    }
                    this.coverUrl = data.coverUrl;
                    this.introduction = data.description;
                    this.noVideoShow = false;
                    var status = data.liveStatus;
                    if (this.countdDownInterval) {

                        window.clearInterval(this.countdDownInterval)
                    }
                    // 调用签到
                    if (data.appointmentStatus === 1 && data.courseType === 2 && (status === 1 || status === 3)) {
                        console.log('调用签到', '111111111111111')
                        // 2024修改直播回放上报进度倍速bug
                        this.liveCourseSignIn()
                    } else {

                        switch (status) {
                            case 0: // 未开始
                                this.noVideoShow = true;
                                this.noDataContent = data.remainingFormatTime
                                this.countdDownInterval = setInterval(() => {
                                    this.noDataContent = this.countdDown(data)
                                }, 1000);  //反复执行函数本身
                                break;
                            case 1: // 直播
                                // this.loadingVideo = true
                                this.videoURL = data.playHlsUrl;
                                this.isLive = true
                                break;
                            case 2:
                                this.noVideoShow = true;
                                this.noDataContent = '直播已结束 回放生成中，请稍后观看'
                                break;
                            case 3:
                                //  this.loadingVideo = true
                                this.videoURL = data.vodMp4Url;
                                break;
                        }    // console.log('调用签到', '222222222222222222222')
                        this.videoInit(data.infoId, '直播公开课');
                        this.initVideoJS(data.infoId);
                    }
                    if (!this.liveCourseAppointment && this.liveLearnData.source === 2) {

                        this.showEnter263Live = true
                    }

                } else {

                    this.$message.error(res.msg);
                    this.handleBack()
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        // 签到
        liveCourseSignIn() {
            liveCourseSignIn({
                "customerId": this.liveLearnData.customerId,
                "courseNo": this.liveLearnData.courseNo,
                "infoId": this.liveLearnData.infoId,
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                // console.log(res, '签到88888888888888888888')
                if (res.code == 200) {
                    var data = res.data
                    console.log(data, '**********************')

                    switch (data.liveStatus) {
                        case 0: // 未开始
                            this.noVideoShow = true;
                            this.noDataContent = data.remainingFormatTime || ''
                            // this.countdDownInterval = setInterval ( () =>{
                            //     this.noDataContent = this.countdDown(data)
                            // }, 1000);  //反复执行函数本身
                            break;
                        case 1: // 直播
                            //this.loadingVideo = true
                            this.videoURL = data.playHlsUrl;
                            this.isLive = true
                            this.videoInit(this.liveLearnData.infoId, '签到');
                            this.initVideoJS(this.liveLearnData.infoId);
                            break;
                        case 2:
                            break;
                        case 3:
                            // this.loadingVideo = true
                            this.aa = 'aa'
                            this.videoURL = data.vodMp4Url;
                            this.bof(data.vodMp4Url, this.liveLearnData.infoId)
                            break;
                    }
                    // this.videoInit(this.liveLearnData.infoId, '签到');
                    // this.initVideoJS(this.liveLearnData.infoId);
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        /**
         * 播放器初始化
         */
        initVideoJS(id) {

            var modeParams = this.modeParams;
            if (modeParams != 'live-learn') {
                let vm = this;
                try {
                    var _this = this;
                    let isMp4 = false
                    let ismpegURL = false
                    let isMp3 = false
                    if (this.liveLearnData.recordType === 1) {
                        var fileName = this.videoURL.substring(this.videoURL.lastIndexOf('/') + 1);
                        isMp4 = fileName.lastIndexOf('.') === -1
                        ismpegURL = !this.videoURL.endsWith('.mp4')
                    } else {
                        isMp3 = this.videoURL.endsWith('.mp3')
                    }
                    let video = document.getElementById('J_VideoJS');
                    let options = {
                        controls: true, //是否显示播放器控件
                        autoplay: true, //是否自动播放
                        width: 767, //视频的宽度
                        height: 429,//视频的高度
                        // aspectRatio: "16:9", //视频的宽高比
                        poster: this.coverUrl, //视频的封面
                        playbackRates: [1, 1.25, 1.5, 2],
                        controlBar: { //底部的控制栏组件
                            currentTimeDisplay: true, //当前播放事件
                            timeDivider: true, //当前播放时间与总时间的斜杆分隔符
                            durationDisplay: true, //是否显示总时间
                            remainingTimeDisplay: false, //是否显示剩下的时间，该选项与是否显示总时间二选一
                            volumePanel: { //音量组件
                                inline: true //可以调整方向为纵向或者横向
                            },
                            children: [ //children数组这是controlbar的子元素顺序
                                {
                                    name: "playToggle"
                                },
                                {
                                    name: "volumePanel"
                                },
                                {
                                    name: "currentTimeDisplay"
                                },
                                {
                                    name: "progressControl"
                                },
                                {
                                    name: "durationDisplay"
                                },
                                {
                                    name: "playbackRateMenuButton",
                                    playbackRates: [1, 1.25, 1.5, 2],
                                },
                                {
                                    name: "FullscreenToggle"
                                }
                            ]
                        },
                        sources: [ // 设置视频的播放源
                            {
                                src: this.videoURL,
                                // type: `video/mp4`, //注意有些类型不兼容如：video/mov
                                type: ismpegURL ? "application/x-mpegURL" : isMp4 ? "video/mp4" : isMp3 ? "audio/mp3" : '',
                                poster: this.coverUrl //视频封面
                            }
                        ]
                    };
                    this.vPlayer = this.$video(video, options, function () {
                        var modeParams = _this.modeParams
                        if (modeParams != 'live-learn') {
                            let timeout = 0;
                            //    var timeCount;
                            this.on('play', function () {
                                if (_this.ISlogVideo) {
                                    _this.LOGvIDEO(_this.$route.params.id)
                                }

                                _this.timeCount = setInterval(function () {
                                    timeout++;
                                    //  2024 - 1 - 24解决上传进度time换本地 localStorage.setItem('miaoTime', timeout)
                                    localStorage.setItem('miaoTime', timeout)
                                    _this.setTimeIS(_this.$route.params.id, 1)
                                    // if(_this.avtiveMenu && _this.avtiveMenu.id && _this.collapseData && _this.collapseData.length !== 0){
                                    //     _this.recursionReduceCollapseDataTime(_this.collapseData,_this.avtiveMenu.id)
                                    // }
                                }, 1000);
                                //    _this.updateProgress(id, timeout);
                                _this.playCount = setInterval(function () {

                                    _this.updateProgress(id, timeout * _this.playbackRate);
                                    timeout = 0;

                                }, 60000);
                            });
                            this.on('pause', function () {
                                console.log('实际播放多少秒', timeout, '倍速', _this.playbackRate, "倍速*实际秒", timeout * _this.playbackRate)
                                _this.updateProgress(id, timeout * _this.playbackRate);
                                timeout = 0;
                                clearInterval(_this.timeCount);
                                clearInterval(_this.playCount);
                            });
                            this.on('timeupdate', (e) => {
                                if (Math.floor(this.duration()) === Math.floor(this.currentTime())) {
                                    _this.studyLessonPosition = 0
                                } else if (Math.floor(this.currentTime())) {
                                    _this.studyLessonPosition = Math.floor(this.currentTime())
                                }
                                _this.setCollapseData(_this.collapseData)
                            });
                            if (_this.avtiveMenu && _this.avtiveMenu.existVideoOrAudio && !_this.isInit) {
                                var lastState = _this.avtiveMenu.lastStudyPosition;
                                var seeked = false;
                                _this.lastState = _this.avtiveMenu.lastStudyPosition || 0
                                // 设置进度条
                                this.on('canplaythrough', function (e) {
                                    if (!seeked) {
                                        seeked = true;
                                        this.currentTime(lastState)
                                    }
                                });
                            }
                            // 监听播放速度改变事件
                            this.on('ratechange', function () {

                                console.log('实际播放多少秒', timeout, '倍速', _this.playbackRate, "倍速*实际秒", timeout * _this.playbackRate)
                                _this.updateProgress(id, timeout * _this.playbackRate);
                                // 获取当前播放速度
                                var playbackRate = this.playbackRate();
                                _this.playbackRate = playbackRate
                                timeout = 0;
                            });
                        }

                    });

                    /***
                     * 添加视频清晰度
                    ****/
                    const controlBar = this.vPlayer.getChild("ControlBar") || null;
                    const qualityButton = new QualityMenuButton(this.vPlayer, {
                        qualitys: vm.qualitys, //传入视频的画质信息
                        defaultQuality: vm.qualitys[0] //传入视频的默认画质
                    });
                    if (controlBar) {
                        controlBar.addChild(
                            qualityButton,
                            {},
                            controlBar.children().length - 2
                        );
                    }
                } catch (err) {
                    // console.log(`initVideoJs Player error => ${err}`);
                }
            }
        },
        videoInit(id, name) {
            console.log(name, '1111111111-----------');
            var _this = this; let timeout = 0;
            if (this.modeParams === 'live-learn' && _this.videoURL) {
                console.log('videoInit')
                if (_this.videoURL.indexOf(".m3u8.mp4") != -1) {
                    _this.videoURL = _this.videoURL.replace(".m3u8.mp4", ".m3u8")
                }
            }
            this.myPlayer = new Aliplayer({
                id: 'J_prismPlayer',
                width: "100%",
                height: "430px",
                autoplay: _this.isLive,
                cover: _this.coverUrl,
                source: _this.videoURL,
                isLive: _this.isLive,
                "controlBarVisibility": "hover",
                "skinLayout": [
                    {
                        name: "bigPlayButton",
                        align: "cc"
                    },
                    /*{
                        "name": "H5Loading",
                        "align": "cc"
                    },*/
                    {
                        "name": "errorDisplay",
                        "align": "tlabs",
                        "x": 0,
                        "y": 0
                    },
                    {
                        "name": "infoDisplay"
                    },
                    {
                        "name": "tooltip",
                        "align": "blabs",
                        "x": 0,
                        "y": 56
                    },
                    {
                        "name": "controlBar",
                        "align": "blabs",
                        "x": 0,
                        "y": 0,
                        "children": [
                            {
                                "name": "progress",
                                "align": "blabs",
                                "x": 0,
                                "y": 44
                            },
                            {
                                "name": "playButton",
                                "align": "tl",
                                "x": 15,
                                "y": 12
                            },
                            {
                                "name": "timeDisplay",
                                "align": "tl",
                                "x": 10,
                                "y": 7
                            },
                            {
                                "name": "fullScreenButton",
                                "align": "tr",
                                "x": 10,
                                "y": 12
                            },
                            {
                                "name": "setting",
                                "align": "tr",
                                "x": 15,
                                "y": 12
                            }
                        ]
                    }
                ]
            }, function (player) {
                // console.log(_this.lastState, '时间1111111');
                // console.log('The player is created.');
                player.seek(_this.lastState)
                _this.loadingVideo = false
            });
            // var modeParams=this.modeParams;
            // if(modeParams!='live-learn'){
            //   this.videoPlay(id);
            // }
            if (name) {
                var player = this.myPlayer;

                player.on("play", function () {
                    console.log('pla-----');
                    _this.timeCount = setInterval(function () {
                        timeout++;

                    }, 1000);
                    _this.playCount = setInterval(() => {
                        liveupdateStudyProgress({
                            "infoId": id, //直播id
                            "studyTime": timeout, //学习时间(单位秒，同录播课)
                            "studyPosition": this.getCurrentTime() //学习位置（同录播课）
                        }, {
                            Authorization: _this.token,
                            DeptId: _this.dept,
                        })
                        timeout = 0;
                    }, 60000);
                })
                player.on("pause", function () {
                    console.log('pause------');
                    liveupdateStudyProgress({
                        "infoId": id, //直播id
                        "studyTime": timeout, //学习时间(单位秒，同录播课)
                        "studyPosition": this.getCurrentTime() //学习位置（同录播课）
                    }, {
                        Authorization: _this.token,
                        DeptId: _this.dept,
                    })

                    timeout = 0;
                    clearInterval(_this.timeCount);
                    clearInterval(_this.playCount);
                })
                // 监听播放速度改变事件
                player.on('speed', function (event) {
                    console.log('speed,-------')
                    var currentSpeed = event.speed; // 获取当前播放倍速
                    console.log('当前播放倍速:', currentSpeed);
                    // 在这里可以根据currentSpeed进行你需要的操作
                });
            }
            _this.loadingVideo = false
        },
        videoPlay(id) {
            var player = this.myPlayer;
            var _this = this;
            var timeout = 0;
            //    var timeCount;
            player.on('play', function () {
                console.log('updateProgress', 44444444444444444444444);
                _this.updateProgress(id, timeout);
                _this.timeCount = setInterval(function () {
                    timeout++;
                    // if(_this.avtiveMenu && _this.avtiveMenu.id && _this.collapseData && _this.collapseData.length !== 0){
                    //     _this.recursionReduceCollapseDataTime(_this.collapseData,_this.avtiveMenu.id)
                    // }
                }, 1000);
                _this.playCount = setInterval(function () {
                    console.log('updateProgress', 555555555555555555555555);
                    _this.updateProgress(id, timeout);
                    timeout = 0;
                }, 60000);
            });
            player.on('pause', function () {
                console.log('updateProgress', 6666666666666666666666666666);
                _this.updateProgress(id, timeout);
                timeout = 0;
                clearInterval(_this.timeCount);
                clearInterval(_this.playCount);
            });
            player.on('timeupdate', (e) => {
                if (Math.floor(player._duration) === Math.floor(player._TimeUpdateStamp)) {
                    this.studyLessonPosition = 0
                } else if (Math.floor(player._TimeUpdateStamp)) {
                    this.studyLessonPosition = Math.floor(player._TimeUpdateStamp)
                }
                _this.setCollapseData(_this.collapseData)
            });
            player.on('durationchange', (e) => {
                // let learnedTime = Math.floor((this.avtiveMenu.lessonTime * 100 * 60 * (this.avtiveMenu.studyProgress * 0.01) * 0.01).toFixed(0))
                // this.recursionCollapseDataTime(this.collapseData,this.avtiveMenu.id,learnedTime)
            });
            this.getVideoStartProgress(player);
        },
        getVideoStartProgress(player) {
            if (this.avtiveMenu && this.avtiveMenu.existVideoOrAudio && !this.isInit) {
                var lastState = this.avtiveMenu.lastStudyPosition;
                var seeked = false;
                this.lastState = this.avtiveMenu.lastStudyPosition || 0
                player.on('canplaythrough', function (e) {
                    if (!seeked) {
                        seeked = true;
                        player.seek(lastState);
                    }
                });
            } else {
                // getVideoProgress(this.recordId,{},{
                //     Authorization:this.token,
                //     DeptId:this.dept
                // }).then(res => {
                //     if(res.code==200){
                //         var data=res.data;
                //         var lastState=data.lastStudyLessonPosition;
                //         var seeked = false; 
                //         this.lastState = data.lastStudyLessonPosition || 0
                //         this.currentKey = data.lastStudyLessonId || null
                //         let lastStudyVideo = this.recursionCollapseData(this.collapseData,data.lastStudyLessonId)
                //         if(lastStudyVideo && this.videoType==1){
                //             this.avtiveMenu = lastStudyVideo
                //             let getTreeArr = this.getTreeArr(this.collapseData,data.lastStudyLessonId,'id',)
                //         }
                //         player.on('canplaythrough',function (e) {
                //             if(!seeked) { 
                //             seeked = true; 
                //             player.seek(lastState);
                //             } 
                //         });
                //         this.isInit = false
                //     }
                //     return;
                // }).catch(err => {
                //    // console.log(err);
                // });
            }

        },
        updateProgress(lessonId, time) {
            //2024-1-24解决上传进度time换本地 localStorage.getItem('miaoTime')
            // var miao = localStorage.getItem('miaoTime') ? Number(localStorage.getItem('miaoTime')) : 0


            let requestMethod = updateStudyProgress;
            if (this.modeParams === 'plan') { // 如果是学习计划进来的
                requestMethod = oldUpdateStudyProgress
            }
            requestMethod({
                "deptId": 0,
                "recordId": this.recordId,
                "studyLessonId": lessonId,
                "studyLessonPosition": this.studyLessonPosition,
                "studyTime": time,
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    if (this.modeParams != 'live-learn') {
                        this.reLoadGetCourseList()
                    }
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        getCourseList(recordId) {
            this.collapseData = [];
            var obj = this;
            let requestMethod = getCourseDetailCatalogue;
            if (this.modeParams === 'plan') { // 如果是学习计划进来的
                requestMethod = oldGetCourseDetailCatalogue
            }
            requestMethod(recordId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                // console.log("********************************3333");
                if (res.code == 200) {
                    var data = res.data;
                    this.detalDataForBf(data)
                    this.collapseData = data;
                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];
                        item["num"] = i + 1;
                        //this.collapseData.push(item);
                    }
                    var { id, url, expandedKeys, lastStudyPosition, newRow } = this.getDefaultPlayInfo(data);
                    if (url != 0) {
                        if (lastStudyPosition) {
                            this.avtiveMenu = {
                                lastStudyPosition,
                                existVideoOrAudio: true,
                                id,
                                url,
                            }
                        }
                        var currentId = id
                        obj.currentKey = expandedKeys.shift();
                        expandedKeys.reverse();
                        obj.videoURL = url;
                        obj.noVideoShow = false;
                        obj.defaultExpandedKeys = expandedKeys;
                        // this.loadingVideo = true
                        // 定位到上一次播放的视频
                        getVideoProgress(this.recordId, {}, {
                            Authorization: this.token,
                            DeptId: this.dept
                        }).then(res => {
                            if (res.code == 200) {
                                var progressData = res.data;
                                if (progressData) {
                                    this.currentKey = progressData.lastStudyLessonId || null
                                    let lastStudyVideo = this.recursionCollapseData(this.collapseData, progressData.lastStudyLessonId)
                                    if (lastStudyVideo && this.videoType == 1) {
                                        this.avtiveMenu = lastStudyVideo
                                        let expandedKeys = this.getTreeArr(this.collapseData, progressData.lastStudyLessonId, 'id',)
                                        // obj.videoURL=lastStudyVideo.recordContentsFileInfo.video.sourceUrl;
                                        if (lastStudyVideo.recordContentsFileInfo.video.highDefinitionUrl) {
                                            obj.videoURL = lastStudyVideo.recordContentsFileInfo.video.highDefinitionUrl;
                                        } else if (lastStudyVideo.recordContentsFileInfo.video.standardDefinitionUrl) {
                                            obj.videoURL = lastStudyVideo.recordContentsFileInfo.video.standardDefinitionUrl;
                                        } else if (lastStudyVideo.recordContentsFileInfo.video.fluencyDefinitionUrl) {
                                            obj.videoURL = lastStudyVideo.recordContentsFileInfo.video.fluencyDefinitionUrl;
                                        } else {
                                            obj.videoURL = lastStudyVideo.recordContentsFileInfo.video.sourceUrl;
                                        }
                                        obj.defaultExpandedKeys = expandedKeys;
                                        currentId = lastStudyVideo.id
                                    }
                                }
                                this.isInit = false
                                obj.videoInit(currentId);
                                obj.initVideoJS(currentId);
                                obj.setDefaultPPT(currentId);
                            }
                        }).catch(err => {
                            // console.log(err);
                        });
                    } else {
                        obj.setDefaultPPT(id, data[0]);
                    }
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        // getCourseIntroduction(recordId) {

        //     let requestMethod = getCourseDetailIntroduction;
        //     if (this.modeParams === 'plan') { // 如果是学习计划进来的
        //         requestMethod = oldGetCourseDetailIntroduction
        //     }
        //     requestMethod(recordId, {}, {
        //         Authorization: this.token,
        //         DeptId: this.dept
        //     }).then(res => {

        //         if (res.code == 200) {

        //             this.liveLearnData = res.data;
        //             if (res.data.imageTextDescription) {
        //                 this.imageTextDescription = this.escape2Html(res.data.imageTextDescription)
        //             }
        //             // var introduction=data.description;
        //             this.coverUrl = res.data.coverUrl;

        //             // this.introduction=introduction.replaceAll("&lt;", "<").replaceAll("&gt;", ">");
        //         }
        //         return;
        //     }).catch(err => {
        //        // console.log(err);
        //     });
        // },
        async getCourseIntroduction(recordId) {
            let requestMethod = getCourseDetailIntroduction;
            if (this.modeParams === 'plan') { // 如果是学习计划进来的
                requestMethod = oldGetCourseDetailIntroduction
            }
            await requestMethod(recordId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {

                if (res.code == 200) {
                    this.liveLearnData = res.data;
                    if (res.data.imageTextDescription) {
                        this.imageTextDescription = this.escape2Html(res.data.imageTextDescription)
                    }
                    // var introduction=data.description;
                    this.coverUrl = res.data.coverUrl;
                    // this.introduction=introduction.replaceAll("&lt;", "<").replaceAll("&gt;", ">");
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },

        setDefaultPPT(id) {
            var data = this.collapseData;
            var row = data[0];
            if (id != 0) {
                row = this.findId(data, id);
            }
            var rowContent = row.recordContentsFileInfo;
            this.recordInfo = rowContent;
        },
        findId(Arr, ID) {
            var _result = null;
            for (let i = 0; i < Arr.length; i++) {
                if (Arr[i].id == ID) return Arr[i];
                if (Arr[i].children) _result = this.findId(Arr[i].children, ID)
                if (_result != null) return _result;
            }
            return _result
        },
        getMenu(params) {
            var row = JSON.parse(params);
            var rowContent = row.recordContentsFileInfo;
            this.recordInfo = rowContent;
            this.avtiveMenu = JSON.parse(params)
            if (this.timeCount) {
                clearInterval(this.timeCount);
            }
            if (this.playCount) {
                clearInterval(this.playCount);
            }
            if (this.videoType == 1) {

                if (rowContent.video && rowContent.video != null && rowContent.video.sourceUrl && rowContent.video.sourceUrl != '') {
                    this.noVideoShow = false;
                    // this.videoURL=rowContent.video.sourceUrl;
                    if (rowContent.video.highDefinitionUrl) {
                        this.videoURL = rowContent.video.highDefinitionUrl;
                    } else if (rowContent.video.standardDefinitionUrl) {
                        this.videoURL = rowContent.video.standardDefinitionUrl;
                    } else if (rowContent.video.fluencyDefinitionUrl) {
                        this.videoURL = rowContent.video.fluencyDefinitionUrl;
                    } else {
                        this.videoURL = rowContent.video.sourceUrl;
                    }
                    this.$nextTick(function () {
                        this.changeVideo(row.id);
                    });
                }
            } else {

                if (rowContent.audio && rowContent.audio != null && rowContent.audio.sourceUrl && rowContent.audio.sourceUrl != '') {
                    this.noVideoShow = false;
                    this.videoURL = rowContent.audio.sourceUrl;
                    this.$nextTick(function () {
                        this.changeVideo(row.id);
                    });
                }
            }
            const { id } = row;
            this.currentKey = id;
            this.defaultExpandedKeys = [id]
        },
        getNumVal(params) {
            this.parseNum = params;
        },
        changeVideo(id) {

            if (this.myPlayer) {
                this.myPlayer.dispose();
            }
            if (this.vPlayer) {
                this.vPlayer.pause() //关闭
                this.vPlayer.dispose();//销毁
                var myVideoDiv = document.getElementById("myVideoDiv")
                myVideoDiv.innerHTML = "<video id='J_VideoJS' class='video-js vjs-big-play-centered'></video>"
                this.vPlayer = null
            }
            this.videoInit(id);
            this.initVideoJS(id);
        },
        getDefaultPlayInfo(data) {
            var id = 0;
            var lastStudyPosition = 0;
            var url = "";
            var expandedKeys = [];
            var newRow = {};
            if (Array.isArray(data)) {
                for (var i = 0; i < data.length; i++) {
                    var { id, url, expandedKeys, lastStudyPosition, newRow } = this.getDefaultPlayInfo(data[i]);
                    if (url != "") {
                        if (data.id) {
                            expandedKeys.push(data.id);
                        }
                        newRow = data[i];
                        return { id, url, expandedKeys, lastStudyPosition, newRow };
                    }
                }
            } else if ('children' in data && data.children.length > 0) {
                for (var i = 0; i < data.children.length; i++) {
                    var { id, url, expandedKeys, lastStudyPosition, newRow } = this.getDefaultPlayInfo(data.children[i]);
                    if (url != "") {
                        if (data.id) {
                            expandedKeys.push(data.id);
                        }
                        newRow = data.children[i];
                        return { id, url, expandedKeys, lastStudyPosition, newRow };
                    }
                }
            } else if ('recordContentsFileInfo' in data && "video" in data.recordContentsFileInfo && data.recordContentsFileInfo.video != null) {
                /* var videoTitle=data.recordContentsFileInfo.video.title;*/
                if (this.videoType == 1) {
                    //  url=data.recordContentsFileInfo.video.sourceUrl;
                    if (data.recordContentsFileInfo.video.highDefinitionUrl) {
                        url = data.recordContentsFileInfo.video.highDefinitionUrl;
                    } else if (data.recordContentsFileInfo.video.standardDefinitionUrl) {
                        url = data.recordContentsFileInfo.video.standardDefinitionUrl;
                    } else if (data.recordContentsFileInfo.video.fluencyDefinitionUrl) {
                        url = data.recordContentsFileInfo.video.fluencyDefinitionUrl;
                    } else {
                        url = data.recordContentsFileInfo.video.sourceUrl;
                    }
                } else {
                    url = data.recordContentsFileInfo.audio.sourceUrl;
                }
                lastStudyPosition = data.lastStudyPosition || 0
                id = data.id;
                newRow = data;
                if (id) {
                    expandedKeys.push(id);
                }
            }
            return { id, url, expandedKeys, lastStudyPosition, newRow };
        },
        // 设置目录数据    lastStudyPosition
        setCollapseData(collapseData) {
            if (collapseData && collapseData.length) {
                collapseData.forEach((item) => {
                    if (this.avtiveMenu && item.id === this.avtiveMenu.id && this.avtiveMenu.existVideoOrAudio) {
                        item.lastStudyPosition = this.studyLessonPosition
                    }
                    if (item.children && item.children.length !== 0) {
                        this.setCollapseData(item.children)
                    }
                })
            }
        },
        // 递归找到上一次播放的视频数据
        recursionCollapseData(collapseData, id) {
            if (!collapseData || collapseData.length === 0) {
                return null
            }
            if (collapseData && collapseData.length !== 0) {
                for (const item of collapseData) {
                    if (item.id === id) {
                        return item;
                    } else if (item.children && item.children.length !== 0) {
                        let result = this.recursionCollapseData(item.children, id)
                        if (result) {
                            return result;
                        }
                    }
                }
            }
        },
        // 递归找到当前数据赋值已学
        recursionCollapseDataTime(collapseData, id, duration) {
            if (!collapseData || collapseData.length === 0) {
                return null
            }
            if (collapseData && collapseData.length !== 0) {
                for (const item of collapseData) {
                    if (item.id === id) {
                        this.$set(item, 'timeLenth', duration)
                        return item;
                    } else if (item.children && item.children.length !== 0) {
                        let result = this.recursionCollapseDataTime(item.children, id, duration)
                        if (result) {
                            this.$set(result, 'timeLenth', duration)
                            return result;
                        }
                    }
                }
            }
        },
        // 递归找到当前数据赋值已学
        recursionReduceCollapseDataTime(collapseData, id) {
            if (!collapseData || collapseData.length === 0) {
                return null
            }
            this.$nextTick(() => {
                if (collapseData && collapseData.length !== 0) {
                    for (const item of collapseData) {
                        if (item.id === id && item.lessonTime !== 0 && (item.timeLenth <= (item.lessonTime * 60) || !item.timeLenth)) {
                            let timeLenth = item.timeLenth + 1
                            this.$set(item, 'timeLenth', timeLenth)
                        } else if (item.children && item.children.length !== 0) {
                            this.recursionReduceCollapseDataTime(item.children, id)
                        }
                    }
                }
            })
        },
        // 获取祖先id
        getTreeArr(data, value, idKey = 'id', childrenKey = 'children') {
            let ids = []
            let recursion = (treeData) => {
                let node
                for (node of treeData) {
                    if (node[idKey] === value) {
                        return node[idKey]
                    } else {
                        if (node[childrenKey] && node[childrenKey].length) {
                            let id = recursion(node[childrenKey])
                            if (id) {
                                ids.push(id)
                                return node[idKey]
                            }
                        }
                    }
                }
                return null
            }
            let id = recursion(data)
            if (id) {
                ids.push(id)
            }
            return ids.reverse()
        },
        // 倒计时
        countdDown(data) {
            var nowtime = new Date(),  //获取当前时间
                endtime = new Date(data.startTime && data.startTime.replace("/-/g", "/"));  //定义结束时间
            // endtime = new Date('2022/7/11/ 18:10:55');  //定义结束时间
            var lefttime = endtime.getTime() - nowtime.getTime(),  //距离结束时间的毫秒数
                leftd = Math.floor(lefttime / (1000 * 60 * 60 * 24)),  //计算天数
                lefth = Math.floor(lefttime / (1000 * 60 * 60) % 24),  //计算小时数
                leftm = Math.floor(lefttime / (1000 * 60) % 60),  //计算分钟数
                lefts = Math.floor(lefttime / 1000 % 60);  //计算秒数
            if (leftd < -1 && this.countdDownInterval) {
                window.clearInterval(this.countdDownInterval)
                return 0 + "天" + 0 + "小时" + 0 + "分钟" + 0 + "秒";
            }
            return leftd + "天" + lefth + "小时" + leftm + "分钟" + lefts + "秒";  //返回倒计时的字符串
        },
        // 重新刷新菜单
        reLoadGetCourseList() {
            var obj = this;
            let requestMethod = getCourseDetailCatalogue;
            if (this.modeParams === 'plan') { // 如果是学习计划进来的
                requestMethod = oldGetCourseDetailCatalogue
            }
            requestMethod(this.recordId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.detalDataForBf(data)
                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];
                        item["num"] = i + 1;
                    }
                    this.collapseData = data;
                    this.$nextTick(() => {
                        this.currentKey = this.avtiveMenu.id
                    })

                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        escape2Html(str) {
            let arrEntities = {
                'lt': '<',
                'gt': '>',
                'nbsp': ' ',
                'amp': '&',
                'quot': '"'
            };
            return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) {
                return arrEntities[t];
            });
        },
        detalDataForBf(data) {
            const deepLevel = {
                "1": "章",
                "2": '节',
                "3": '篇',
                "4": '点'
            }
            const numberMap = ['一', '二', '三', '四']
            //   const queue = []
            //   queue.push(...data)
            //   while (queue.length) {
            //     const len = queue.length
            //    // console.log(len, 'len')
            //     for (let i = 0; i < len; i++) {
            //       const { level, children } = queue[i], addText = deepLevel[String(level)]
            //       queue[i].title = `第${numberMap[i]}${addText}：${queue[i].title}`
            //       if (children) {
            //         queue.push(...children)
            //       }
            //     }
            //     for (let j = 0; j < len; j++) {
            //       queue.shift()
            //     }
            //   }
            if (data && data.length !== 0) {
                data.forEach((item, index) => {
                    const addText = deepLevel[String(item.level)]
                    item.title = `第${index + 1}${item.name}：${item.title}`
                    if (item.children && item.children !== 0) {
                        this.detalDataForBf(item.children)
                    }
                });
            }
            return data

        },
        // 将数字（整数）转为汉字，从零到一亿亿，需要小数的可自行截取小数点后面的数字直接替换对应arr1的读法就行了
        convertToChinaNum(num) {
            var arr1 = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
            var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿']
            if (!num || isNaN(num)) {
                return '零'
            }
            var english = num.toString().split('')
            var result = ''
            for (var i = 0; i < english.length; i++) {
                var des_i = english.length - 1 - i
                result = arr2[i] + result
                var arr1_index = english[des_i]
                result = arr1[arr1_index] + result
            }
            result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十')
            result = result.replace(/零+/g, '零')
            result = result.replace(/零亿/g, '亿').replace(/零万/g, '万')
            result = result.replace(/亿万/g, '亿')
            result = result.replace(/零+$/, '')
            result = result.replace(/^一十/g, '十')
            return result
        },
        /**取消预约 */
        cancelBook() {
            this.bookComfirm = false;
            this.showLiveCourseAppointment = false
        },
        /**确定预约 */
        dealBook() {
            var _this = this;
            this.requestBook(function () {
                _this.bookComfirm = false;
                _this.$message({
                    message: '预约成功',
                    type: 'success'
                });
                location.reload()
            });
        },
        // 点击预约按钮
        bookLive(row) {
            var recordId = this.$route.params.id;
            appointmentCourseTimes(recordId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(async (res) => {
                if (res.code == 200) {
                    var times = res.data.times;
                    if (times > 0 || times == 0) {
                        this.bookTimes = times;
                        this.bookComfirm = true;
                    } else {
                        //免费课
                        var _this = this;
                        await this.requestBook(function () {
                            _this.$message({
                                message: '预约成功',
                                type: 'success'
                            });
                            location.reload()
                        });
                    }
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        // 公开课预约
        onLiveCourseAppointment() {
            onlineOpenCourseDetail(this.liveLearnData.infoId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {

                if (res.code == 200) {
                    const activeCompany = JSON.parse(window.localStorage.getItem('activeCompany'));
                    if (activeCompany) {
                        this.companyDetail = activeCompany
                    }
                    if (res.data.companyList && activeCompany) {
                        res.data.companyList.forEach((item) => {
                            if (item.deptId == Number(activeCompany.deptId)) {
                                item["check"] = Number(item.deptId);
                            } else {
                                item["check"] = "";
                            }
                        })
                    }
                    this.liveCourseAppointmentData = Object.assign(this.liveCourseAppointmentData, res.data)
                    this.showLiveCourseAppointment = true
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        // 提交公开课预约
        submitLiveCourseAppointment() {
            appointmentOnlineOpenCourse({
                "crmCompanyId": this.companyDetail.crmCompanyId,
                "deptId": this.companyDetail.deptId,
                "infoId": this.liveLearnData.infoId,
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.showLiveCourseAppointment = false
                    // this.$message({
                    //     message: '预约成功！',
                    //     type: 'success'
                    // });
                    this.tipTitle = ''
                    this.tipVisible = true
                    this.showLiveCourseAppointment = false
                    setTimeout(() => {
                        this.tipVisible = false
                        location.reload()
                    }, 1000);
                } else {
                    this.showLiveCourseAppointment = false
                    this.tipTitle = '温馨提示'
                    this.tipVisible = true
                    this.tipMsg = res.msg
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        handleDropdown(row) {
            var target = row.deptId;
            this.companyDetail = row
            var companyData = this.liveCourseAppointmentData.companyList;
            for (var i = 0; i < companyData.length; i++) {
                var item = companyData[i];
                if (item.deptId == target) {
                    this.liveCourseAppointmentData.companyList[i]["check"] = target;
                } else {
                    this.liveCourseAppointmentData.companyList[i]["check"] = '';
                }
            }
            // this.switchCompanyChange(row.deptId)
            // this.changeCompany(row);
        },
        async requestBook(callback) {
            var recordId = this.$route.params.id;
            await appointmentCourse(recordId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    callback();
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        // 进入263直播
        enter263Live() {
            getLiveAuthAddress(this.liveLearnData.infoId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {

                if (res.code == 200) {
                    window.open(res.data.authUrl, '_blank')
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
    },
    beforeDestroy() {
        if (this.countdDownInterval) {
            window.clearInterval(this.countdDownInterval)
        }
        if (this.timeCount) {
            clearInterval(this.timeCount);
        }
        if (this.playCount) {
            clearInterval(this.playCount);
        }
    }
}
</script>

<style scoped>
.dialog-content {
    /* background: #333; */
    padding: 15px 40px
}

.company-dropdown-wrap {
    max-height: 170px;
    overflow-y: scroll;
    /* overflow: hidden; */
    width: 350px;
    text-overflow: ellipsis;
    /* white-space: nowrap;  */
}

.page-container {
    width: 100%;
    margin: 0 auto;
}

.page-wrapper {
    width: 1200px;
    margin: 0 auto;
    padding: 100px;
}

.page-back-wrapper {
    width: 100%;
    height: 68px;
    background: #ffffff;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #f0f0f3;
    display: flex;
    align-items: center;
    margin-top: 18px;
}

.page-back-img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    display: inline-block;
    position: relative;
    top: 2px;
}

.page-back {
    display: flex;
    align-items: center;
    margin-left: 30px;
    cursor: pointer;
}

.page-content-wrapper {
    margin-top: 18px;
}

.jyxz {
    cursor: pointer;
    right: 10px;
    top: 10px;
    font-size: 12px;
    position: absolute;
    width: 80px;
    background: #4f79ed;
    height: 25px;
    line-height: 25px;
    text-align: center;
    border-radius: 20px;
    color: #fff;
    font-weight: 600;
}

.page-content {
    display: flex;
    height: 430px;
    background: #353938;
}

.video-wrapper {
    width: 767px;
    height: 100%;
    position: relative;
    margin: 0 auto;
}

.no-video {
    color: #fff;
    height: 64px;
    position: absolute;
    box-sizing: border-box;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
}

.no-video-wrapper {
    color: #fff;
    height: 64px;
    position: absolute;
    box-sizing: border-box;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 430px;

}

.no-video-img-wrapper {
    width: 100%;
    height: 430px;
}

.no-video-icon {
    font-size: 80px;
    cursor: pointer;
}

.catalogue-wrapper {
    flex: 1;
    height: 100%;
    background: #353938;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    overflow-y: auto;
    color: #fff;
    position: relative;
}

.page-content-detail {
    background: #ffffff;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #f0f0f3;
    margin-top: 18px;
}

.catalogue-header {
    text-align: center;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #fff;
    display: flex;
    padding: 10px;
    font-size: 20px;
    font-weight: 600;
    display: flex;
    align-items: center;
}

.collapse-label {
    margin-left: 5px;
}

.page-content-detail-header {
    height: 50px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: #333333;
    display: flex;
    align-items: center;
    background: #f8faff;
}

.page-content-detail-header-item {
    width: 100px;
    height: 100%;
    line-height: 50px;
    text-align: center;
}

.page-content-detail-header-item-active {
    width: 100px;
    height: 100%;
    line-height: 50px;
    text-align: center;
    color: #4f79ed;
    cursor: pointer;
    background: #fff;
}

.page-content-detail-header-item:hover {
    cursor: pointer;
    color: #4f79ed;
}

.catalogue-collapse {
    padding: 0px 15px 0px 15px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    height: 370px;
    overflow: hidden;
    overflow-y: auto;
}

.catalogue-collapse>>>.el-collapse {
    border: 0 !important;
}

.catalogue-collapse>>>.el-collapse-item__header {
    border: 0 !important;
    background: #353938 !important;
    color: #fff;
}

.catalogue-collapse>>>.el-collapse-item__wrap {
    background: #353938 !important;
    color: #fff;
}

.catalogue-collapse>>>.el-tree-node__content {
    background: #353938 !important;
    color: #fff;
}

/* 滚动条设置 */
:deep(.catalogue-collapse)::-webkit-scrollbar {
    width: 10px;
}

:deep(.catalogue-collapse)::-webkit-scrollbar-track {
    background: #e0e0e0;
    border-radius: 10px;
}

:deep(.catalogue-collapse)::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}

.catalogue-collapse {
    scrollbar-width: thin;
    scrollbar-color: #888 #e0e0e0;
}

.collapse-child {
    font-size: 14px;
    color: #999999;
    height: 35px;
    line-height: 35px;
    display: flex;
}

.collapse-child:hover {
    cursor: pointer;
}

.catalogue-collapse>>>.el-collapse-item__arrow {
    color: #fff !important;
    /* font-size: 18px !important;
    font-weight: 600 !important; */
}

.catalogue-collapse>>>.el-collapse-item__wrap {
    border: 0 !important;
}

/* 课程目录 */
.catalogue-content-wrapper {
    padding: 0px 15px 0px 15px;
    /* font-size: 18px; */
    font-family: PingFangSC-Semibold, PingFang SC;
    /* font-weight: 600; */
}

.catalogue-content-wrapper>>>.el-collapse {
    border: 0 !important;
}

.catalogue-content-wrapper>>>.el-collapse-item__header {
    border: 0 !important;
    background: #fff !important;
    color: #333;
}

.catalogue-content-wrapper>>>.el-collapse-item__wrap {
    background: #fff !important;
    color: #333;
}

.catalogue-content-wrapper>>>.el-tree-node__content {
    background: #fff !important;
    color: #333;
    padding: 12px;
    height: 35px;
    color: #333;
    border-bottom: 1px solid #eaeaee;
}

.catalogue-content-wrapper>>>.el-collapse-item__arrow {
    color: #333 !important;
    font-size: 18px !important;
    font-weight: 600 !important;
}

.catalogue-content-wrapper>>>.el-collapse-item__wrap {
    border: 0 !important;
}

/* 目录结束 */
.collapse-icon {
    font-size: 25px;
    display: inline-block;
    position: relative;
    top: 5px;
    margin-left: 8px;
    color: #fff;
}

.page-content-detail-content-header {
    font-weight: 600;
    text-align: center;
    padding: 50px 0px 30px 0px;
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #333333;
    width: 200px;
    margin: 0 auto;
    position: relative;
}

.induction-wrapper {
    width: 674px;
    background: #ffffff;
    box-shadow: 0px 2px 12px 8px rgba(255, 241, 235, 0.25);
    border-radius: 6px;
    border: 1px solid #ece7e4;
    padding: 32px;
    margin: 0 auto;
    min-height: 300px;
}

.catalogue-content-wrapper {
    /* width:90%;
  margin:0 auto; */
    min-height: 300px;
    margin-top: 20px;
}

.menu-img {
    width: 20px;
    height: 18px;
    margin-right: 17px;
    display: inline-block;
    position: relative;
    top: 2px;
}

.circle-img1-wrapper {
    position: absolute;
    top: 40px;
    left: 20px;
}

.circle-img1 {
    width: 33px;
    height: 33px;
}

.circle-img2-wrapper {
    position: absolute;
    top: 40px;
    right: 30px;
}

.circle-img2 {
    width: 18px;
    height: 18px;
}

.page-content-detail-content-header-title {
    position: relative;
    z-index: 30;
}

.video-wrapper>>>.vjs-big-play-button {
    width: 70px !important;
    height: 70px !important;
    border: 0px !important;
    font-size: 60px !important;
    line-height: 70px !important;
    left: 50% !important;
    top: 50% !important;
    /* transform: translate(-50%, -50%) !important; */
}

.induction-content {
    width: 100%;
}

.induction-content>>>img {
    width: 100%;
    max-width: 100%;
}

p>>>img {
    width: 100%;
}

.ppt-image {
    width: 100%;
}

.course-pay-wrapper {
    width: 100%;
    height: 92px;
    background: #fff;
    /* margin-top: 20px; */
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.course-pay-btn {
    width: 200px;
    height: 52px;
    background: #3E63EE;
    border-radius: 6px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
}

.live-learn-time {
    width: 100%;
    height: 60px;
    font-size: 18px;
    /* background:#fff; */
    /* margin-bottom:20px; */
    display: flex;
    align-items: center;
    padding-left: 15px;
}

.live-learn-title-wrapper {
    margin-left: 30px;
    font-size: 18px;
}

.live-learn-title {
    font-weight: 600;
}

.live-learn-title-flag {
    font-size: 14px;
    margin-left: 15px;
    color: #999999;
}

.live-course-appointment,
.dialog-appointment-btn-wrapper {
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
}
</style>
<style lang="less" scoped>
/deep/ .video-js .vjs-current-time,
.vjs-no-flex .vjs-current-time {
    display: block !important;
}

/deep/ .video-js .vjs-duration,
.vjs-no-flex .vjs-duration {
    display: block !important;
}

.appointment-active-container {
    border-radius: 8px;

    .course-name-wrap {
        margin-bottom: 20px;
        font-size: 15px;
    }

    .page-info-content-company-name {
        display: inline-flex;
        align-items: center;
    }

    .page-info-refresh {
        display: inline-flex;
        position: relative;
        margin-left: 11px;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 102px;
        height: 26px;
        // margin-top:5px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #F6986D;
        cursor: pointer;
    }

    .compony-dropdown {
        width: 102px;
        height: 26px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .page-info-set {
        width: 76px;
        height: 26px;
        display: flex;
        margin-left: 21px;
        align-items: center;
        justify-content: center;
        text-align: center;
        height: 26px;
        margin-top: 5px;
        cursor: pointer;
        line-height: 26px;
        position: relative;
    }

    .page-info-shape-wrapper {
        width: 102px;
        height: 26px;
        position: absolute;
        top: 0px;
        left: 0px;
    }

    .desc-wrap {
        color: #666666;
        font-size: 15px;
    }

    .dialog-appointment-btn-wrapper {
        .submit-btn {
            width: 100%;
            background: #3E63EE;
            margin-top: 35px;
        }

        margin-bottom: 20px;
    }

    .course-name-tabs {
        /deep/ .el-tabs__item {
            font-size: 24px;
            color: #666666;
        }

        /deep/ .el-tabs__active-bar {
            height: 0;
        }
    }
}

.success-tip-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .success-tip-logo {
        margin-bottom: 10px;
    }
}

.error-tip-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .tip-text {
        margin-bottom: 10px;
    }
}

.branch-image {
    width: 10px;
    margin-right: 8px;
}
</style>
<style lang="less">
.resetDialog {
    border-radius: 8px !important;

    .info {
        margin: 12px 0 12px 0;
        color: #666666;
        font-size: 20px;
        font-weight: 500;
        word-break: break-all;
    }

    .el-form-item {
        margin-bottom: 0px;
    }

    .el-form-item__label {
        text-align: right;
        vertical-align: middle;
        float: left;
        font-size: 14px;
        color: #606266;
        line-height: 26px;
        padding: 0 12px 0 0;
        box-sizing: border-box;
    }

    .el-form-item__content {
        line-height: 26px;
        position: relative;
        font-size: 14px;
    }
}

.appointment-active-container {
    border-radius: 8px;

    .el-dialog__header {
        text-align: center;
        background: #F0F0F3;
        border-radius: 8px;
    }
}

.appointment-tip-container {
    border-radius: 8px;
    text-align: center;
    // background: whitesmoke;
}

.empty {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.empty::after {
    content: attr(alt);
    position: absolute;
    bottom: 0;
}

.empty img {
    width: 220px;
    height: 210px;
}

//目录滚动条样式修改
.catalogue-wrapper::-webkit-scrollbar {
    width: 4px;
}

.catalogue-wrapper::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 5px;
}

.catalogue-wrapper::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 5px;
}

.catalogue-wrapper::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.dialog-exchange-wrapper .dialog-exchange-content .dialog-btn-wrapper {
    display: flex;
    justify-content: center;
}

.el-rate__icon {

    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-size: 30px !important;
}
</style>
